import React from 'react';
import { combineEpics, ofType } from 'redux-observable';
import { map, switchMap, catchError, mergeMap, takeUntil, startWith } from 'rxjs/operators';
import { createErrorStream } from 'common/store/error';
import { of } from 'rxjs';
import { Actions as FarceActions } from 'farce';
import { defineMessages } from 'react-intl';
import { actions as notificatonActions } from 'common/mdc/notifications';
import {
  TYPE_SUCCESS, TYPE_ERROR,
} from 'common/mdc/notifications/notification';
import * as R from 'ramda';
import { PublicError } from 'common/service/error';
import GroupLink from '@sma/components/group/link';

import {
  LOAD,
  CLEAR,
  ADD_DEVICES,
  REMOVE_DEVICES,
  ADD_AND_REMOVE_DEVICES,
  loadSuccess,
  saveSuccess,
  loadError,
  editError,
  removeDevices,
} from './actions';

import {
  actions as nodesActions,
} from '../devices';

const messages = defineMessages({
  add: {
    id: 'group.add',
    defaultMessage: 'Added device(s) to Group {groupName} Successfully',
  },
  remove: {
    id: 'group.remove',
    defaultMessage: 'Removed device(s) from Group {groupName} successfully',
  },
  error: {
    id: 'group.error',
    defaultMessage: 'Group {groupName} could not be updated',
  },
});

const loadGroup = (action, state, { groupServiceUi }) => action.pipe(
  ofType(LOAD),
  switchMap(action$ => groupServiceUi
    .getById(action$.groupId)
    .pipe(
      map(loadSuccess),
      takeUntil(action.pipe(ofType(CLEAR))),
      catchError(createErrorStream(action$, loadError)),
      startWith(nodesActions.load(action$.groupId)),
    )),
);

const addDevicesToGroup = (action, state, { groupService }) => action.pipe(
  ofType(ADD_DEVICES),
  switchMap(action$ => groupService
    .addDevices(action$.group)
    .pipe(
      mergeMap(group => of(
        saveSuccess(group),
        FarceActions.push(`/groups`),
        notificatonActions.addNotification({
          type: TYPE_SUCCESS,
          autoHide: true,
          text: <GroupLink groupId={action$.group.groupId} groupName={action$.group.groupName} message={messages.add} />,
        }),
      )),
      catchError(createErrorStream(
        action$,
        editError,
        err => notificatonActions.addNotification({
          type: TYPE_ERROR,
          autoHide: true,
          text: R.is(PublicError, err) && err.message
            ? err.message
            : (<GroupLink
              groupId={action$.group.groupId}
              groupName={action$.group.groupName}
              message={messages.error}
            />),
        }),
      )),
    )),
);

const removeDevicesFromGroup = (action, state, { groupService }) => action.pipe(
  ofType(REMOVE_DEVICES),
  switchMap(action$ => groupService
    .removeDevices(action$.group)
    .pipe(
      mergeMap(group => of(
        saveSuccess(group),
        FarceActions.push(`/groups`),
        notificatonActions.addNotification({
          type: TYPE_SUCCESS,
          autoHide: true,
          text: <GroupLink groupId={action$.group.groupId} groupName={action$.group.groupName} message={messages.remove} />,
        }),
      )),
      catchError(createErrorStream(
        action$,
        editError,
        err => notificatonActions.addNotification({
          type: TYPE_ERROR,
          autoHide: true,
          text: R.is(PublicError, err) && err.message
            ? err.message
            : (<GroupLink
              groupId={action$.group.groupId}
              groupName={action$.group.groupName}
              message={messages.error}
            />),
        }),
      )),
    )),
);

const addAndRemoveDevices = (action, state, { groupService }) => action.pipe(
  ofType(ADD_AND_REMOVE_DEVICES),
  switchMap(action$ => groupService
    .addDevices(action$.addGroup)
    .pipe(
      mergeMap(group => of(
        saveSuccess(group),
        notificatonActions.addNotification({
          type: TYPE_SUCCESS,
          autoHide: true,
          text: <GroupLink groupId={action$.addGroup.groupId} groupName={action$.addGroup.groupName} message={messages.add} />,
        }),
        removeDevices(action$.removeGroup),
      )),
      catchError(createErrorStream(
        action$,
        editError,
        err => notificatonActions.addNotification({
          type: TYPE_ERROR,
          autoHide: true,
          text: R.is(PublicError, err) && err.message
            ? err.message
            : (<GroupLink
              groupId={action$.addGroup.groupId}
              groupName={action$.addGroup.groupName}
              message={messages.error}
            />),
        }),
      )),
    )),
);



export default combineEpics(
  loadGroup,
  addDevicesToGroup,
  removeDevicesFromGroup,
  addAndRemoveDevices,
);
